import { FormikHelpers } from "formik";
import { InstallmentCalculatorSchema } from "./InstallmentCalculator/schema";

export const parseValueToNumber = (value: string): number => {
  const formattedValue = value
    .replace("R$", "")
    .replace(/\./g, "")
    .replace(",", ".");
  return Number(formattedValue);
};

export const formatNumberToPtBr = (value: number) => {
  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return formatter.format(value);
};

export const formatPercent = (number?: number, toFixed = 2) => {
  return number ? number.toFixed(toFixed).replace(".", ",") : undefined;
};

export const formatTaxValue = ({ taxaIof }: { taxaIof: number }) => {
  return `${taxaIof.toFixed(3).replace(".", ",")}%`;
};

export const onChangeInitialValue = (
  value: string,
  setFieldValue: FormikHelpers<InstallmentCalculatorSchema>["setFieldValue"]
) => {
  const numericValue = value.replace(/\D/g, "");

  const integerPart = numericValue.slice(0, -2) || "0";
  const decimalPart = numericValue.slice(-2).padStart(2, "0");

  const formattedValue = `${parseInt(integerPart, 10).toLocaleString(
    "pt-BR"
  )},${decimalPart}`;

  setFieldValue("initialValue", `R$ ${formattedValue}`);
};
